
    <label class="custom-file-upload">
        <input type="file" (change)="fileChangeEvent($event)" />
        <span  [hidden]="hasFile" class="btn btn-primary btn-sm">Select File</span>
        {{fileName}}<br>
        <button *ngIf="hasFile" class="btn btn-primary btn-sm" (click)="uploadFile()">Submit File</button>
    </label>
